/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import mbpLogger from 'mbp-logger';
import { string } from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import { setMiddlePlaceOrderSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Actions';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import { getMiddlePlaceOrderSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';

const MiddlePlaceOrderButtonABTest = ({ pageType }) => {
    const dispatch = useDispatch();
    const middlePlaceOrderBtnSFABTestData = useSelector(getMiddlePlaceOrderSaleForceABTest);

    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        interactionName: 'Get Campaign - Place Order Button',
        targeting: { pageType },
        featureFlag: true,
        apolloOptions: {
            fetchPolicy: 'cache-first',
        },
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });

    if ((loading) || (!loading && !data && !error)) {
        return null;
    }

    if (error) {
        mbpLogger.logError({
            function: 'MiddlePlaceOrderButtonABTest',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'Middle Place Order Btn Salesforce AB test returned an error',
            jsError: error,
        });
    }

    if (
        data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup
        && data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup !== middlePlaceOrderBtnSFABTestData?.campaign?.campaignResponses?.[0]?.userGroup
    ) {
        dispatch(setMiddlePlaceOrderSaleForceABTest(data.contentSF));
    }

    return null;
};

MiddlePlaceOrderButtonABTest.propTypes = {
    pageType: string.isRequired,
};

export default MiddlePlaceOrderButtonABTest;
